import axios from 'axios';
import type { FiltersInterface, ParamInterface } from '../types/Miscellaneous';

import type { ProjectBaselineInterface, ProjectPhaseSlugType } from '../types/Project';
import { baseUrl, HttpMethods } from './base';

//******************Project Core START********************/

export async function getProjectActivitiesTemplate() {
  const res = await axios.get(`${baseUrl.SHERPA}/projects/activities/template`);
  return res.data.data;
}

export async function getProjectActivities(projectId: string, projectPhase: string) {
  const res = await axios.get(`${baseUrl.SHERPA}/projects/${projectId}/activities?phase=${projectPhase}`);
  return res.data.data;
}

export async function createNewProject(project: any) {
  const resp = await axios.post(`${baseUrl.SHERPA}/projects`, project);
  return resp.data;
}

export async function patchProjectStatus(projectId: number, status: string) {
  const resp = await axios.patch(`${baseUrl.SHERPA}/projects/${projectId}`, {
    status,
  });
  return resp.data;
}

interface PostLoadProjectTemplateService {
  projectId: number;
  data: PostLoadProjectTemplatePayload;
}

interface PostLoadProjectTemplatePayload {
  projectTemplateId: number;
}

export async function loadSherpaTemplate({ projectId, data }: PostLoadProjectTemplateService) {
  const resp = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/projects/${projectId}/activities/load`,
    data,
  });
  return resp.data;
}

interface GetProjectsParamsInterface {
  params: ParamInterface | FiltersInterface;
}

export async function getProjects({ params }: Partial<GetProjectsParamsInterface>) {
  const res = await axios.get(`${baseUrl.SHERPA}/projects`, { params });

  //TODO: Data duplication for pagination view
  // const originalProjects = res.data.data;

  // const fakeProjects = Array.from({ length: 90 }, (_, index) => {
  //   const project = originalProjects[index % originalProjects.length];

  //   return {
  //     ...project,
  //     id: 100000 + index + 1, // unique deterministic fake id
  //     name: `Fake Project ${index + 1}`,
  //   };
  // });

  // return {
  //   ...res.data,
  //   data: [...originalProjects, ...fakeProjects],
  //   meta: {
  //     ...res.data.meta,
  //     total: originalProjects.length + fakeProjects.length,
  //   },
  // };

  return res.data;
}

export async function uploadProjectThumbnail({ data }: UploadProjectThumbnailService) {
  const res = await axios({
    headers: { 'Content-Type': data.type },
    method: HttpMethods.PUT,
    url: data.url,
    data: data.file,
    withCredentials: false,
  });
  return res.data;
}

export interface SaveProjectThumbnailPayload {
  name: string;
  key: string;
  contentType: string;
  size: number;
}
interface SaveProjectThumbnailService {
  data: SaveProjectThumbnailPayload;
  projectId: number;
}

export async function saveProjectThumbnail({ data, projectId }: SaveProjectThumbnailService) {
  const res = await axios({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/projects/${projectId}/save_thumbnail`,
    data,
  });
  return res.data;
}

//******************Project Core END********************/

//******************Project Baseline START********************/

interface updateProjectBaselineSerivce {
  projectId: number;
  data: ProjectBaselineInterface;
}

export async function updateProjectBaseline({ projectId, data }: updateProjectBaselineSerivce) {
  const resp = await axios({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/projects/${projectId}`,
    data,
  });
  return resp.data;
}

//******************Project Baseline END********************/

//******************Project Team START********************/

export interface UploadProjectThumbnailPayload {
  url: string;
  type: string;
  file: File;
}
interface UploadProjectThumbnailService {
  data: UploadProjectThumbnailPayload;
}

interface PostExternalProjectMemberService {
  data: PostExternalProjectMemberPayload;
}

export interface PostExternalProjectMemberPayload {
  projectId: number;
  vendorId: string;
  phaseId: ProjectPhaseSlugType;
}

export async function postExternalProjectMember({ data }: PostExternalProjectMemberService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/svtn/vendors/project/assign`,
    data,
  });
  return res.data;
}

//******************Project Team END********************/
